import { HouseCreateRequest } from "@1games-ru/region-shared/dist/backend/requests/estate";
import { useCallback } from "react";
import CreateEntityMpProvider from "@/core/data-provider/data-mp/create-entity/create-entity-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import toast from "@/domains/toasts/helpers/toast";

export default function useCreateHouse() {
  const createHouse = useCallback(async (data: HouseCreateRequest) => {
    try {
      const response = await CreateEntityMpProvider.createHouse(data);
      if (response instanceof RpcMpProviderSuccessResponse) {
        toast.success("Дом создан");
        return response.data;
      }
      console.log({ data, response });
      toast.error("Ошибка создания дома");
      return false;
    } catch (e) {
      console.log(e);
      toast.error("Ошибка создания дома");
      return false;
    }
  }, []);

  return {
    createHouse,
  };
}
